var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagixGroupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 85,
    viewBox: "0 0 148 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2104_3541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0005 0V42.6253C53.0005 31.3502 42.3975 28.5712 42.3975 17.4024C42.3975 10.4931 46.024 4.10764 51.9013 0.645377L53.0005 0Z",
    fill: "url(#paint0_radial_2104_3541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.397 17.4023V34.2505L21.206 18.5261V49.8838C21.206 51.6301 21.4602 53.2018 21.9388 54.6672L13.2126 48.1906C12.9509 47.9932 12.7116 47.7882 12.4873 47.5605H12.4798C3.8434 39.8235 3.46953 29.2849 10.603 24.7369L9.51129 25.3822C3.61907 28.8521 0 35.2299 0 42.1393V42.3747C0 53.5511 10.5955 56.33 10.5955 67.6051V50.3925L31.794 66.117V34.7516C31.794 33.0205 31.5248 31.4336 31.0388 29.953L39.7799 36.4372C40.0341 36.6422 40.2734 36.8548 40.5127 37.075C49.1491 44.8119 49.523 55.472 42.3895 60.02L43.4513 59.3974C49.3585 55.9352 52.9925 49.5421 52.9925 42.6252C52.9925 31.3501 42.3895 28.5712 42.3895 17.4023H42.397Z",
    fill: "url(#paint1_radial_2104_3541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4721 47.5528C3.83569 39.8235 3.46182 29.2848 10.5953 24.7368V42.982C10.5953 44.7131 11.2832 46.3532 12.4721 47.5528Z",
    fill: "url(#paint2_radial_2104_3541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5127 37.0752C49.1491 44.8045 49.523 55.4722 42.3895 60.0203V41.7751C42.3895 40.0439 41.7016 38.2748 40.5127 37.0752Z",
    fill: "url(#paint3_radial_2104_3541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5955 67.605C10.5133 74.4308 6.89419 80.7099 1.06179 84.1342L0 84.7568V42.3745C0 53.5509 10.5955 56.3298 10.5955 67.605Z",
    fill: "url(#paint4_radial_2104_3541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 84.9998V42.3745C0 53.6496 10.603 56.4286 10.603 67.5974C10.603 74.5067 6.97644 80.8922 1.09918 84.3544L0 84.9998Z",
    fill: "url(#paint5_radial_2104_3541)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2104_3541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0005 0V42.6863C53.0005 31.395 42.3975 28.6121 42.3975 17.4273C42.3975 10.5081 46.024 4.11352 51.9013 0.646301L53.0005 0Z",
    fill: "url(#paint6_linear_2104_3541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.397 17.4272V34.2995L21.206 18.5526V49.9552C21.206 51.704 21.4602 53.2779 21.9388 54.7454L13.2126 48.2596C12.9509 48.0619 12.7116 47.8566 12.4873 47.6285H12.4798C3.8434 39.8805 3.46953 29.3268 10.603 24.7723L9.51129 25.4186C3.61907 28.8934 0 35.2804 0 42.1996V42.4353C0 53.6277 10.5955 56.4106 10.5955 67.7019V50.4646L31.794 66.2116V34.8013C31.794 33.0677 31.5248 31.4786 31.0388 29.9959L39.7799 36.4893C40.0341 36.6946 40.2734 36.9075 40.5127 37.128C49.1491 44.876 49.523 55.5514 42.3895 60.1059L43.4513 59.4824C49.3585 56.0152 52.9925 49.613 52.9925 42.6862C52.9925 31.395 42.3895 28.6121 42.3895 17.4272H42.397Z",
    fill: "#3ECF8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4721 47.6211C3.83569 39.8807 3.46182 29.327 10.5953 24.7725V43.0438C10.5953 44.7774 11.2832 46.4197 12.4721 47.6211Z",
    fill: "url(#paint7_radial_2104_3541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5127 37.1279C49.1491 44.8683 49.523 55.5513 42.3895 60.1058V41.8345C42.3895 40.1009 41.7016 38.3293 40.5127 37.1279Z",
    fill: "url(#paint8_radial_2104_3541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 84.9998V42.3135C0 53.6047 10.603 56.3876 10.603 67.5724C10.603 74.4917 6.97644 80.8862 1.09918 84.3535L0 84.9998Z",
    fill: "url(#paint9_radial_2104_3541)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8651 41.0909H67.0568L72.6705 54.7926H72.892L78.5057 41.0909H82.6974V60H79.4105V47.0092H79.2351L74.0092 59.9446H71.5533L66.3274 46.9815H66.152V60H62.8651V41.0909ZM88.8558 60H85.1996L91.8565 41.0909H96.0852L102.751 60H99.0952L94.0447 44.9688H93.897L88.8558 60ZM88.9759 52.5859H98.9474V55.3374H88.9759V52.5859ZM117.021 47.1293C116.867 46.6307 116.655 46.1844 116.384 45.7905C116.119 45.3904 115.799 45.0488 115.424 44.7656C115.054 44.4825 114.63 44.2701 114.15 44.1286C113.669 43.9808 113.146 43.907 112.58 43.907C111.564 43.907 110.659 44.1624 109.865 44.6733C109.071 45.1842 108.447 45.9351 107.991 46.9261C107.542 47.911 107.317 49.1113 107.317 50.527C107.317 51.955 107.542 53.1645 107.991 54.1555C108.44 55.1465 109.065 55.9006 109.865 56.4176C110.666 56.9285 111.595 57.1839 112.654 57.1839C113.614 57.1839 114.445 56.9993 115.147 56.63C115.855 56.2607 116.399 55.7375 116.781 55.0604C117.163 54.3771 117.353 53.5769 117.353 52.6598L118.129 52.7798H112.995V50.1023H120.668V52.3736C120.668 53.9924 120.323 55.3928 119.634 56.5746C118.944 57.7564 117.997 58.6674 116.79 59.3075C115.584 59.9415 114.199 60.2585 112.635 60.2585C110.893 60.2585 109.364 59.8677 108.047 59.0859C106.735 58.2981 105.711 57.1809 104.972 55.7344C104.239 54.2817 103.873 52.5582 103.873 50.5639C103.873 49.0374 104.089 47.674 104.52 46.4737C104.957 45.2734 105.566 44.2547 106.348 43.4176C107.129 42.5743 108.047 41.9342 109.099 41.4972C110.152 41.054 111.297 40.8324 112.534 40.8324C113.58 40.8324 114.556 40.9863 115.461 41.294C116.365 41.5956 117.169 42.0265 117.87 42.5866C118.578 43.1468 119.16 43.8116 119.615 44.581C120.071 45.3504 120.369 46.1998 120.511 47.1293H117.021ZM127.406 41.0909V60H123.98V41.0909H127.406ZM133.977 41.0909L138.141 48.0156H138.289L142.472 41.0909H146.377L140.551 50.5455L146.469 60H142.499L138.289 53.1214H138.141L133.931 60H129.979L135.953 50.5455L130.053 41.0909H133.977Z",
    fill: "#3ECF8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4 29H62.344V17.432H69.4V18.872H63.912V22.488H68.856V23.88H63.912V27.544H69.4V29ZM74.5521 23.224L70.6001 17.432H72.4721L74.2801 20.008C74.7921 20.76 75.1761 21.4 75.5121 22.04L78.5681 17.432H80.3761L76.5041 23.208L80.4241 29H78.5681L76.7921 26.456C76.3441 25.8 75.9121 25.096 75.5281 24.424L72.4241 29H70.5841L74.5521 23.224ZM86.3159 29.176C83.0199 29.176 80.8279 26.808 80.8279 23.224C80.8279 19.656 83.0839 17.24 86.3959 17.24C89.0039 17.24 91.0039 18.792 91.4359 21.16H89.7559C89.3239 19.656 88.0279 18.744 86.3479 18.744C84.0119 18.744 82.4759 20.504 82.4759 23.208C82.4759 25.912 84.0119 27.672 86.3479 27.672C88.0439 27.672 89.3879 26.76 89.8199 25.336H91.4839C90.9879 27.64 88.9239 29.176 86.3159 29.176ZM94.9745 29H93.4065V17.432H94.9745V22.408H100.703V17.432H102.271V29H100.703V23.864H94.9745V29ZM105.433 29H103.801L108.025 17.432H109.769L114.009 29H112.361L111.321 26.12H106.457L105.433 29ZM108.697 19.928L106.937 24.76H110.857L109.081 19.928C109.001 19.704 108.921 19.432 108.889 19.256C108.857 19.416 108.777 19.688 108.697 19.928ZM117.115 29H115.547V17.432H117.115L123.035 26.376V17.432H124.603V29H123.035L117.115 20.056V29ZM132.257 18.712C129.761 18.712 128.257 20.552 128.257 23.288C128.257 26.088 129.889 27.704 132.273 27.704C134.241 27.704 135.825 26.696 135.825 24.36V24.024H131.953V22.632H137.297V29.016H135.985L135.873 27.448C135.249 28.456 133.841 29.192 132.145 29.192C128.865 29.192 126.609 26.824 126.609 23.256C126.609 19.736 128.881 17.24 132.289 17.24C134.817 17.24 136.785 18.696 137.169 20.92H135.505C135.073 19.448 133.793 18.712 132.257 18.712ZM147.072 29H140.016V17.432H147.072V18.872H141.584V22.488H146.528V23.88H141.584V27.544H147.072V29Z",
    fill: "#3ECF8E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2104_3541",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6657 9.19372) rotate(74.3788) scale(26.0743 13.8976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#51A87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#45956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#357A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B6A4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2104_3541",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.585 42.4206) rotate(45.7781) scale(27.6193 41.4166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DC4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#73C09A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#55AE80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#45956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2D6B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2C6A4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2104_3541",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4524 27.6436) rotate(82.0805) scale(13.7994 8.43074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#58B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#51A87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#46956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#367A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C6A4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2104_3541",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3158 57.1261) rotate(-97.9195) scale(13.8753 8.47711)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#58B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#51A87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#46956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#367A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C6A4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2104_3541",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.654203 73.2987) rotate(-106.431) scale(20.816 12.9471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88CDD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#85C9D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7CBDC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6EAAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#5A8FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#406C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5476"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2104_3541",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.255103 75.8254) rotate(-105.621) scale(26.0743 13.8976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#51A87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#45956D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#357A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B6A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2104_3541",
    x1: 52.9107,
    y1: 21.2899,
    x2: 45.994,
    y2: 26.0551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#55B585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#45AD7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2104_3541",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4524 27.6834) rotate(82.0917) scale(13.8188 8.43097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#57B685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4BB07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#38A775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2104_3541",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9919 57.3607) rotate(-97.9083) scale(13.8948 8.47734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#57B685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4BB07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#38A775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2104_3541",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.00068 75.5942) rotate(-105.6) scale(26.1089 13.8991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5BB888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#57B685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4BB07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#38A775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A472"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2104_3541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 85,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2104_3541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagixGroupLogo);
export default __webpack_public_path__ + "static/media/magixGroupLogo.b064449777d2ff7e47e59e3d644124b5.svg";
export { ForwardRef as ReactComponent };